module.exports = "dist/24d5e25c3beabb095762b5d118069f45.svg";